import { render, staticRenderFns } from "./Songs.vue?vue&type=template&id=32aaa4e5&scoped=true"
import script from "./Songs.vue?vue&type=script&lang=js"
export * from "./Songs.vue?vue&type=script&lang=js"
import style0 from "./Songs.vue?vue&type=style&index=0&id=32aaa4e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aaa4e5",
  null
  
)

export default component.exports